import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, ShoppingBag } from 'lucide-react';
const names = ['Martín R.', 'Carlos G.', 'Lucas F.', 'Pablo A.', 'Diego R.', 'Javier M.', 'Facundo S.', 'Gonzalo T.', 'Matías L.', 'Nicolás P.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Santa Fe', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'San Juan'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setCurrentPurchase({
        name: randomName,
        city: randomCity,
        time: `Hace ${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay — first popup after 30s
    const initialTimeout = setTimeout(showPopup, 30000);
    // Recurring — a new popup every 30 seconds
    const interval = setInterval(() => {
      showPopup();
    }, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-264">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -20
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-200 p-4 flex items-center gap-4 max-w-sm" data-id="element-265">
          <div className="bg-[#F0FFE5] p-3 rounded-full text-[#00CC00]" data-id="element-266">
            <ShoppingBag size={24} data-id="element-267" />
          </div>
          <div data-id="element-268">
            <p className="text-sm text-gray-800" data-id="element-269">
              <span className="font-bold" data-id="element-270">{currentPurchase.name}</span> compró
              el
            </p>
            <p className="text-sm font-bold text-[#00CC00]" data-id="element-271">
              Megapack RUGBY 360
            </p>
            <div className="flex items-center gap-1 text-xs text-gray-500 mt-1" data-id="element-272">
              <MapPin size={12} data-id="element-273" />
              <span data-id="element-274">
                {currentPurchase.city}, Argentina • {currentPurchase.time}
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}